import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import TextLoader from '../../../components/global/Loader/text';
import EmptyData from '../../../components/global/emptyData';
import Pagination from '../../../components/global/List/Pagination';
import Doctor from '../Appointments/doctor';
import DoctorSkeleton from './doctorSkeleton';

export default function PastAppointmentsV2({
  pastRef,
  section,
  setCurrentPage,
  goToCurrentAppointments,
  isVisible,
  city,
}) {
  const history = useHistory();
  const { skeleton, detailsMap, loadingProviders, loading, pagination } = section;

  const onClickButton = (e) => {
    e.preventDefault();
    history.push('/');
  };

  useEffect(() => {
    if (skeleton?.length && pastRef.current) {
      window.scrollTo(0, pastRef.current.offsetTop);
    }
  }, [skeleton, pastRef]);

  if (!isVisible) return null;

  if (!skeleton || (loading && !skeleton.length)) return <TextLoader />;

  return (
    <div className="streaming-records-current disabled" ref={pastRef}>
      <div className="streaming-records-title streaming-records-title--with-action">
        <div className="streaming-records-title-records-wrapper">
          <button
            type="button"
            className="streaming-records-title-records-item"
            onClick={goToCurrentAppointments}
          >
            <i className="fas fa-calendar-alt" />
            Майбутні записи
          </button>
          <button
            type="button"
            className="streaming-records-title-records-item active"
            aria-current="page"
          >
            <i className="fas fa-history" />
            Минулі записи
          </button>
        </div>
        <Button className="streaming-records-title-book-btn" onClick={onClickButton}>
          Записатись на прийом
        </Button>
      </div>

      {skeleton && skeleton.length > 0 ? (
        <>
          {skeleton.map((item) => {
            const full = detailsMap[item.id];
            if (full) {
              return <Doctor key={item.id} city={city} isPast {...full} />;
            }
            return (
              <DoctorSkeleton
                key={item.id}
                {...item}
                isLoading={loadingProviders.has(item.provider_id)}
              />
            );
          })}
          {pagination && (
            <Pagination
              currentPage={pagination.current_page}
              totalPages={pagination.total_pages}
              pageName="page"
              setPageHandler={setCurrentPage}
            />
          )}
        </>
      ) : (
        <EmptyData />
      )}
    </div>
  );
}
